import React, { useState, useEffect } from "react";
import Main from "../Main/Main";
import Top from "../Top/Top";
import "./Home.css";

const Home = ({ setActiveScreen, }) => {
    const [count, setCount] = useState(0);
    const [complete, setComplete] = useState("");
    const [isComplete, setIsComplete] = useState(false);
    const [message, setMessage] = useState("");
    const [index, setIndex] = useState(0);
    const [enter, setEnter] = useState("　　　　　　　　");


    const text = "Welcome to AoyamaTaro's Website!";
    const toTheTop = "top";

    const handleClick = () => {
        setActiveScreen(toTheTop); // 状態を更新
        console.log("fff");
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (count < 100) {
                setCount((prevCount) => prevCount + 1);
                setComplete((prevComplete) => prevComplete = "Now Loading...");
            } else {
                clearInterval(intervalId);
                setComplete((prevComplete) => prevComplete = "Completed!");
                setEnter((prevEnter) => prevEnter = "[Enter]");
                setIsComplete(true);

            }
        }, 40);
        return () => clearInterval(intervalId);

    }, [count])

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (index < text.length) {
                setMessage((prev) => prev + text[index]);
                setIndex((prevIndex) => prevIndex + 1);
            } else {
                clearInterval(intervalId);

            }
        }, 50);

        return () => clearInterval(intervalId);
    }, [index, text.length]);








    return (
        <div className="home-wrapper">
            <div className="home-contents">
                <div className="home-message">
                    {message}

                </div>
                <div className="home-loading-bar">
                    <div className="home-blink">
                        {count}%
                    </div>
                </div>
                <div className={isComplete ? "home-completed" : "home-now-loading"}>
                    {complete}
                </div>
                <div
                    onClick={handleClick}
                    className={isComplete ? "home-enter-wrapper-completed" : "home-enter-wrapper"}>
                    <p className="home-enter-hover">[Enter]</p>
                </div>
            </div>


        </div >
    );




};

export default Home;
